import { GROUP_CODES } from 'src/constants/code.constants';

export function isHappyCaseOrPhotoKit(groupCode: GROUP_CODES) {
  return [
    GROUP_CODES.HAPPY_CASE_CLASSIC,
    GROUP_CODES.HAPPY_CASE_VINTAGE,
    GROUP_CODES.FOTOKIT_HOMEDECOR,
    GROUP_CODES.FOTOKIT_MINISCRAP,
  ].includes(groupCode);
}

export function isHappyCase(groupCode: GROUP_CODES) {
  return [GROUP_CODES.HAPPY_CASE_CLASSIC, GROUP_CODES.HAPPY_CASE_VINTAGE].includes(groupCode);
}

export function isPhotoKit(groupCode: GROUP_CODES) {
  return [GROUP_CODES.FOTOKIT_HOMEDECOR, GROUP_CODES.FOTOKIT_MINISCRAP].includes(groupCode);
}

export function isMultiGroup(groupCode: GROUP_CODES) {
  return [
    GROUP_CODES.HAPPY_CASE_CLASSIC,
    GROUP_CODES.HAPPY_CASE_VINTAGE,
    GROUP_CODES.FOTOKIT_HOMEDECOR,
    GROUP_CODES.FOTOKIT_MINISCRAP,
  ].includes(groupCode);
}
